// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { currentUser, loading } = useAuth();

    console.log('ProtectedRoute:', { currentUser, loading, path: window.location.pathname });

    if (loading) {
        return (
            <div className="loading-screen">
                <div className="loader"></div>
                <p>Initializing secure connection...</p>
            </div>
        );
    }

    if (!currentUser) {
        return <Navigate to="/login" />;
    }

    return children;
};

export default ProtectedRoute;